/**
 *  @swagger
 *  definitions:
 *    RegattaTrackEventRegattaCourseParams:
 *      type: object
 *      properties:
 *        RegattaTrackEventId:
 *          description: ID of the associated RegattaTrackEvent
 *          type: string
 *        RegattaCourseId:
 *          description: ID of the associated RegattaCourse
 *          type: string
 *
 *  @swagger
 *  definitions:
 *    RegattaTrackEventRegattaCourseCreateParams:
 *      allOf:
 *        - $ref: '#/definitions/RegattaTrackEventRegattaCourseParams'
 *        - type: object
 *          required:
 *            - RegattaTrackEventId
 *            - RegattaCourseId
 *
 *  @swagger
 *  definitions:
 *    RegattaTrackEventRegattaCourseQueryParams:
 *      allOf:
 *        - type: object
 *          properties:
 *            id:
 *              description: ID of the RegattaTrackEventRegattaCourse
 *              type: string
 *        - $ref: '#/definitions/RegattaTrackEventRegattaCourseParams'
 *
 *  @swagger
 *  definitions:
 *    RegattaTrackEventRegattaCourseUpdateParams:
 *      allOf:
 *        - $ref: '#/definitions/RegattaTrackEventRegattaCourseQueryParams'
 *        - type: object
 *          required:
 *            - id
 *
 *  @swagger
 *  definitions:
 *    RegattaTrackEventRegattaCourse:
 *      allOf:
 *        - $ref: '#/definitions/RegattaTrackEventRegattaCourseCreateParams'
 *        - $ref: '#/definitions/RegattaTrackEventRegattaCourseUpdateParams'
 *        - $ref: '#/definitions/Timestamps'
 *
 *  @swagger
 *  components:
 *    schemas:
 *      RegattaTrackEventRegattaCourse:
 *        allOf:
 *          - $ref: '#/definitions/RegattaTrackEventRegattaCourse'
 *          - type: object
 *            properties:
 *              RegattaTrackEvent:
 *                description: RegattaTrackEvent of the RegattaTrackEventRegattaCourse
 *                $ref: '#/components/schemas/RegattaTrackEvent'
 *              RegattaCourse:
 *                description: RegattaCourse of the RegattaTrackEventRegattaCourse
 *                $ref: '#/components/schemas/RegattaCourse'
 */

// Types
import type {
  $Model,
  $ModelClass,
  $ModelClasses,
} from '.';
import type {
  $Field,
} from '../types';

export type $RelationIds = {
  RegattaCourseId: string;
  RegattaTrackEventId: string;
};

export type $DTO = Record<string, never>;

export type $CreateParams = $RelationIds;

export type $UpdateParams = {
  id: string;
} & Partial<$CreateParams>;

export type $UpsertParams = $CreateParams & {
  id?: string;
};

export type $QueryParams = {
  id?: null | string;
} & Partial<$RelationIds>;

export type $Associations = {
  RegattaCourse?: $Model<'RegattaCourse'>;
  RegattaTrackEvent?: $Model<'RegattaTrackEvent'>;
};

export type $ModelParams = $Associations & $CreateParams & {
  id: string;
};

type $Fields = {
  id: string;
};

const fields = (
  Sequelize,
): Record<keyof $Fields, $Field> => ({
  id: {
    allowNull: false,
    defaultValue: Sequelize.UUIDV4,
    primaryKey: true,
    type: Sequelize.UUID,
    unique: true,
  },
});

export default ((
  Sequelize,
  stack,
): $ModelClass<'RegattaTrackEventRegattaCourse'> => {
  const RegattaTrackEventRegattaCourse = stack.define(
    'RegattaTrackEventRegattaCourse',
    fields(Sequelize),
    {
      tableName: 'RegattaTrackEventRegattaCourses',
    },
  );

  RegattaTrackEventRegattaCourse.associate = (models: $ModelClasses) => {
    models.RegattaTrackEventRegattaCourse.belongsTo(
      models.RegattaTrackEvent,
      {
        as: 'RegattaTrackEvent',
        foreignKey: 'RegattaTrackEventId',
      },
    );
    models.RegattaTrackEventRegattaCourse.belongsTo(
      models.RegattaCourse,
      {
        as: 'RegattaCourse',
        foreignKey: 'RegattaCourseId',
      },
    );
  };

  return RegattaTrackEventRegattaCourse;
});
